/** Zero-width and soft-hyphen characters sometimes used as orch title placeholders. */
const INVISIBLE_TITLE_CHARS = /[\u200B-\u200D\uFEFF\u00AD]/g;

/** True when a section title should render visible heading chrome (not a silent row-break). */
export function hasVisibleSectionTitle(title?: string): boolean {
  if (title == null || title === '') return false;
  return title.replace(INVISIBLE_TITLE_CHARS, '').trim().length > 0;
}
